import { ReactNode } from "react";
import WhatsAppIcon from "@/assets/Icons/whatsapp-green.svg?react";
import CallIcon from "@/assets/Icons/call-blue.svg?react";
import MailIcon from "@/assets/Icons/mail-blue.svg?react";
import { Card } from "@/components/Card";

interface ContactItemProps {
  icon: ReactNode;
  text: string;
  href: string;
}

const ContactItem = ({ icon, text, href }: ContactItemProps) => (
  <a
    href={href}
    className="flex items-center gap-4 text-gray-700 hover:text-gray-900 transition-colors"
  >
    {icon}
    <span className="text-base">{text}</span>
  </a>
);

interface MarisolContactSectionProps {
  title: string;
  image?: string;
}

export const MarisolContactSection = ({
  title,
  image,
}: MarisolContactSectionProps) => (
  <div className="flex flex-col gap-6 w-full md:pl-36 md:pb-[8rem]">
    <h2 className="text-xl md:text-2xl">{title}</h2>

    <Card
      className="relative w-full bg-[#f9f9f9] !rounded-3xl pl-8 md:pl-24 overflow-visible"
      raised={false}
      rest={false}
    >
      <div className="flex flex-col gap-6">
        <ContactItem
          icon={<WhatsAppIcon className="w-7 h-7 flex-shrink-0" />}
          text="+1 (832) 755-6099"
          href="https://wa.me/18327556099"
        />
        <ContactItem
          icon={<CallIcon className="w-7 h-7 flex-shrink-0" />}
          text="+1 (832) 730-2683"
          href="tel:+18327302683"
        />
        <ContactItem
          icon={<MailIcon className="w-7 h-7 flex-shrink-0" />}
          text="support@sendolapay.com"
          href="mailto:support@sendolapay.com"
        />
      </div>

      {image && (
        <img
          src={image}
          alt="Contact"
          className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 w-[42%] max-w-md object-cover rounded-3xl"
        />
      )}
    </Card>
  </div>
);
